// import React, { useState } from "react";
// import { Modal, Button, Form } from "react-bootstrap";
// import config from "../../config/config";
// import axios from "axios";
// import { toast } from "react-toastify";
// import { getAuthToken } from "../../utils/token";
// const SupplierModal = ({ show, handleClose, selectedId, onMaterial,fetchAcceptedList }) => {
//   const [inputValue, setInputValue] = useState("");
//   const [loading, setLoading] = useState(false);
//   const approveButton = async () => {
//     if (!inputValue.trim()) {
//       toast.warning("Please enter supplier name");
//       return;
//     }
//     const token = getAuthToken();
//     if (!token) {
//       toast.error("Authentication failed");
//       return;
//     }
//     setLoading(true);
//     try {
//       const response = await axios.put(
//         `${config.API}/supervisor/accept/${selectedId}`,
//         { supplier: inputValue }, 
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             "Content-Type": "application/json",
//           },
//         }
//       );
//       toast.success(response.data?.message || "Material approved successfully");
//       onMaterial()
//       fetchAcceptedList()
//       handleClose();
//       setInputValue("");
//     } catch (error) {
//       console.error("Error approving material:", error.response?.data || error.message);
//       toast.error(error.response?.data?.message || "Failed to approve material");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <Modal show={show} onHide={handleClose} centered>
//       <div className="m-3">
//         <Modal.Body className="font_family">
//           <h5 className="fw-bold mb-3">Supplier</h5>
//           <Form>
//             <Form.Group controlId="supplierInput">
//               <Form.Label>Name</Form.Label>
//               <Form.Control
//                 type="text"
//                 placeholder="Enter supplier name..."
//                 value={inputValue}
//                 onChange={(e) => setInputValue(e.target.value)}
//                 disabled={loading}
//               />
//             </Form.Group>
//           </Form>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={handleClose} disabled={loading}>
//             Close
//           </Button>
//           <Button variant="dark" onClick={approveButton} disabled={loading}>
//             Approve
//           </Button>
//         </Modal.Footer>
//       </div>
//     </Modal>
//   );
// };

// export default SupplierModal;


import React, { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { FaPlus, FaTrash } from "react-icons/fa";
import config from "../../config/config";
import axios from "axios";
import { toast } from "react-toastify";
import { formatDate } from "../../utils/formatDate";
import { getAuthToken } from "../../utils/token";
import Loader from "../loader/Loader";

const SupplierModal = ({
  show,
  handleClose,
  selectedId,
  onMaterial,
  fetchAcceptedList,
}) => {
  const [rows, setRows] = useState([
    { quantity: "", batchId: "", supplier: "" },
  ]);
  const [materialDetails, setMaterialDetails] = useState(null);
  const [loading, setLoading] = useState(false);
  const handleChange = (index, field, value) => {
    const updated = [...rows];
    updated[index][field] = value;
    setRows(updated);
  };

  const addRow = () => {
    setRows([...rows, { quantity: "", batchId: "", supplier: "" }]);
  };
  const deleteRow = (index) => {
    if (rows.length === 1) return;
    const updated = rows.filter((_, i) => i !== index);
    setRows(updated);
  };

  const approveButton = async () => {
    const token = getAuthToken();
    if (!token) {
      toast.error("Authentication failed");
      return;
    }
    setLoading(true);
    try {
      const formattedPayload = rows.map((row) => ({
        quantity_received: Number(row.quantity),
        batch_id: row.batchId,
        supplier_name: row.supplier,
      }));
      const response = await axios.put(
        `${config.API}/supervisor/accept/${selectedId}`,
        formattedPayload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      toast.success(response?.data?.message || "Material approved successfully");
      onMaterial();
      fetchAcceptedList();
      handleClose();
      setRows([{ quantity: "", batchId: "", supplier: "" }]);

    } catch (error) {
      const errorMessage =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        "Failed to approve material";
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (show && selectedId) {
      fetchDetails();
    }
  }, [show, selectedId]);

  const fetchDetails = async () => {
    const token = getAuthToken();
    if (!token) return;

    try {
      const response = await axios.get(
        `${config.API}/supervisor/materialissueshow/${selectedId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      const result = response?.data || null;
      setMaterialDetails(result);
    } catch (err) {
      console.error("Error fetching fetchDetails:", err.message);
      setMaterialDetails(null);
    }
  };

  return (
    <Modal show={show} onHide={handleClose} centered size="lg">
      {loading ? (
        <Loader />
      ) : (
        <Modal.Body className="p-4 font_family">
          <h4 className="fw-bold mb-4">Material Issue Receipt</h4>

          <div
            style={{
              background: "#f1f3f5",
              padding: "20px",
              borderRadius: "6px",
              marginBottom: "30px",
            }}
          >
            <h6 className="fw-bold mb-3">Material Information</h6>

            <div className="d-flex justify-content-between">
              <div>
                <p className="mb-1">
                  Material Name:{" "}
                  <strong>
                    {
                      materialDetails?.materialissueshow?.material_master
                        ?.material_name
                    }
                  </strong>
                </p>
                <p className="mb-1">
                  Qty Expected:{" "}
                  <strong>
                    {materialDetails?.materialissueshow?.quantity}
                  </strong>
                </p>
              </div>

              <div>
                <p className="mb-1">
                  Material ID:{" "}
                  <strong>
                    {
                      materialDetails?.materialissueshow?.material_master
                        ?.material_code
                    }
                  </strong>
                </p>
                <p className="mb-1">
                  Date of Receipt:{" "}
                  <strong>
                    {formatDate(
                      materialDetails?.materialissueshow?.created_at
                    )}
                  </strong>
                </p>
              </div>
            </div>
          </div>

          <div className="d-flex fw-bold mb-2">
            <div style={{ width: "23%" }}>Quantity Received</div>
            <div style={{ width: "28%" }}>Batch ID</div>
            <div style={{ width: "35%" }}>Supplier Name</div>
            <div style={{ width: "14%" }}>Action</div>
          </div>

          {rows.map((row, index) => (
            <div
              className="d-flex mb-3 align-items-center"
              key={index}
            >
              <Form.Control
                style={{ width: "23%", marginRight: "10px" }}
                type="text"
                value={row.quantity}
                onChange={(e) =>
                  handleChange(index, "quantity", e.target.value)
                }
                disabled={loading}
              />

              <Form.Control
                style={{ width: "28%", marginRight: "10px" }}
                type="text"
                value={row.batchId}
                onChange={(e) =>
                  handleChange(index, "batchId", e.target.value)
                }
                disabled={loading}
              />

              <Form.Select
                style={{ width: "35%", marginRight: "10px" }}
                value={row.supplier}
                onChange={(e) =>
                  handleChange(index, "supplier", e.target.value)
                }
                disabled={loading}
              >
                <option value="">Select Supplier</option>
                <option value="SHARDA FORGING">SHARDA FORGING</option>
                <option value="UNIQUE FORGING">UNIQUE FORGING</option>
                <option value="PRAG IND. UNIT-II">PRAG IND. UNIT-II</option>
                <option value="SURENDRA ELASTOMERS">SURENDRA ELASTOMERS</option>
                <option value="DPM ENGINEERING WORKS">DPM ENGINEERING WORKS</option>
                <option value="V.TECH CHEMICALS">V.TECH CHEMICALS</option>
              </Form.Select>

              <div className="d-flex">
                {index === 0 && (
                  <div
                    onClick={addRow}
                    style={{
                      width: "30px",
                      height: "30px",
                      border: "1px solid #ccc",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      cursor: "pointer",
                      marginRight: "8px",
                    }}
                  >
                    <FaPlus size={12} />
                  </div>
                )}

                <div
                  onClick={() => deleteRow(index)}
                  style={{
                    width: "30px",
                    height: "30px",
                    border: "1px solid #dc3545",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor:
                      rows.length === 1
                        ? "not-allowed"
                        : "pointer",
                    opacity: rows.length === 1 ? 0.5 : 1,
                  }}
                >
                  <FaTrash size={12} color="#dc3545" />
                </div>
              </div>
            </div>
          ))}
        </Modal.Body>
      )}

      <Modal.Footer>
        <Button
          variant="secondary"
          onClick={handleClose}
          disabled={loading}
        >
          Close
        </Button>

        <Button
          variant="dark"
          onClick={approveButton}
          disabled={loading}
        >
          {loading ? "Approving..." : "Approve"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default SupplierModal;